// extracted by mini-css-extract-plugin
export default {"base":"Reject_base__Tkh60","base_pub":"Reject_base_pub__7jXTB","base__left":"Reject_base__left__ahz-s","base__right":"Reject_base__right__4kDrf"};